module.exports = __webpack_public_path__ + "f5052b2e5be9c8228a3d3f1d36841544.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/soy natural.png
// module id = 624
// module chunks = 0